// https://dev.to/hansott/how-to-check-if-string-is-member-of-union-type-1j4m
const REMINDER_STRINGS = ["both", "sms", "email"] as const;
type ReminderStringTuple = typeof REMINDER_STRINGS;
export type ReminderString = ReminderStringTuple[number];

export function isReminderString(value: string): value is ReminderString {
  return REMINDER_STRINGS.includes(value as ReminderString)
}
